"use client";

import type { ActionButtonProps } from "@/components/ActionButton";
import { ActionGroup } from "@/components/ActionGroup";
import BackgroundSvg from "@/components/BackgroundSvg";
import { Container } from "@/components/Container";
import {
	AdaptiveText,
	type AdaptiveTextProps,
	Title,
} from "@/components/Content";
import Features, { type FeatureProps } from "@/components/Features";
import {
	StaggerContainer,
	StaggerItem,
} from "@/components/animations/page-transitions";

type Props = FeatureProps & {
	title?: string;
	text?: AdaptiveTextProps["portableText"];
	actions?: ActionButtonProps[];
	id?: string;
	className?: string;
};

const CenterContentWithVerticalGrid = ({
	title,
	text,
	actions,
	features,
	id,
	className,
}: Props) => {
	return (
		<section id={id} className="relative">
			<BackgroundSvg />
			<Container
				className={className}
				containerClassName="pt-12 pb-24 lg:pt-24 lg:pb-32"
			>
				<StaggerContainer>
					<StaggerItem>
						<Title className="text-center text-4xl/[0.9] sm:text-5xl/[0.8] md:text-6xl/[0.8]">
							{title}
						</Title>
					</StaggerItem>
					<StaggerItem>
						<AdaptiveText
							portableText={text}
							className="mt-4 text-center text-base/7 sm:text-lg/8"
						/>
					</StaggerItem>
					<StaggerItem>
						<ActionGroup actions={actions} className="mt-10 justify-center" />
					</StaggerItem>
					<Features.Grid features={features} threeColumns={false} />
				</StaggerContainer>
			</Container>
		</section>
	);
};

export default CenterContentWithVerticalGrid;
